module.exports = __webpack_public_path__ + "img/camera.c832d85f.svg";